// extracted by mini-css-extract-plugin
export default {"container":"Wj-z","links":"Xj-z"};